import React from 'react';

import { CaretIcon } from '@src/Components/Icons';

import styles from './ButtonBackPortal.module.scss';
import { ButtonBackPortalProps } from './ButtonBackPortal.type';

const MythicMarkIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <g clipPath="url(#clip0_btn_back_portal)">
      <path
        d="M5.33795 9.00023C5.33795 10.2656 6.27369 11.314 7.48989 11.4997V6.50049C6.27369 6.6865 5.33795 7.73484 5.33795 9.00023Z"
        fill="currentColor"
      />
      <path
        d="M4.28774 9.00013C4.28774 7.15236 5.69001 5.63218 7.49017 5.44055V1.48646L0.5 0V18L7.49017 16.5665V12.5597C5.69001 12.3681 4.28774 10.8476 4.28774 9.00013Z"
        fill="currentColor"
      />
      <path
        d="M10.662 9.00023C10.662 7.73484 9.72629 6.6865 8.50983 6.50049V11.4997C9.72629 11.314 10.662 10.2654 10.662 9.00023Z"
        fill="currentColor"
      />
      <path
        d="M8.50983 1.48646V5.44055C10.31 5.63218 11.7123 7.15236 11.7123 9.00013C11.7123 10.8479 10.31 12.3681 8.50983 12.5597V16.5665L15.5 18V0L8.50983 1.48646Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_btn_back_portal">
        <rect width="15" height="18" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

/**
 * Header affordance that takes the user back to the Mythic Portal.
 *
 * Rendered as a real anchor so it is keyboard reachable, middle-clickable and
 * never subject to popup blocking. The label stays in the accessibility tree at
 * every viewport and becomes visible text from 1024px up, where the centered
 * page title leaves room for it.
 */
const ButtonBackPortal: React.FC<ButtonBackPortalProps> = ({
  href,
  label = 'Return to Portal',
  onClick
}) => {
  if (!href) return null;

  return (
    <div className={styles['Container']}>
      <a
        data-testid="button-back-portal"
        className={styles['BackLink']}
        href={href}
        title={label}
        onClick={onClick}
      >
        <span className={styles['CaretIcon']} aria-hidden="true">
          <CaretIcon />
        </span>
        <span className={styles['MarkIcon']}>
          <MythicMarkIcon />
        </span>
        <span className={styles['Label']}>{label}</span>
      </a>
    </div>
  );
};

export default ButtonBackPortal;
